import { motion } from 'framer-motion';
import { FaFileAlt, FaAward, FaEdit } from 'react-icons/fa';

import { ViewCard } from '../../../../component/common/ViewCard/view-card';
import Icon from "../../../../components/common/Icon";

type CardItem = {
  id: string;
  title: string;
  description?: string;
  routePath: (processId: number) => string;
  icon?: React.ReactNode;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
};

const cardData = (processId: number, testId?: number): CardItem[] => [
  {
    id: "view-edital",   title: "Ver Edital",
    description: "Acesse os detalhes e regras do processo seletivo.",
    routePath: () => `/process/${processId}/edital`,
    icon: <Icon icon={FaFileAlt} size={36} />,
    backgroundColor: "#fff3e0",
    textColor: "#e65100",
    className: "bg-warning-soft",
  },
  {
    id: "view-results",    title: "Ver Resultados",
    description: "Confira sua classificação e notas.",
    routePath: () => `/process/${processId}/exam`,
    icon: <Icon icon={FaAward} size={36} />,
    backgroundColor: "#e8f5e9",
    textColor: "#2e7d32",
    className: "bg-success-soft shadow-lg",
  },
  {
    id: "view-essay",    title: "Ver Redação",
    description: "Acesse a redação e veja suas redações e comentários.",
    routePath: () => `/process/${processId}/essay`,
    icon: <Icon icon={FaFileAlt} size={36} />,
    backgroundColor: "#e0f2f1",
    textColor: "#00695c",
    className: "bg-primary-soft",
  },
  {
    id: "create-resource",    title: "Criar Recurso",
    description: "Solicite a revisão de alguma questão ou resultado.",
    routePath: () => `/process/${processId}/resource`,
    icon: <Icon icon={FaEdit} size={36} />,
    backgroundColor: "#f3e5f5",
    textColor: "#7b1fa2",
    className: "bg-purple-soft",
  },
];

type ViewListCardProps = {
  processId: number;
  testId?: number;
};

export function ViewListCard({ processId, testId }: ViewListCardProps) {
  const cards = cardData(processId, testId);

  return (
    <div className="container py-4">
      <div className="row g-4 justify-content-center">
        {cards.map((card, index) => (
          <motion.div
            key={card.id}
            className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ViewCard
              title={card.title}
              description={card.description}
              icon={card.icon}
              routePath={card.routePath(processId)}
              backgroundColor={card.backgroundColor}
              textColor={card.textColor}
              className={card.className}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
